"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSLATION_URL_ORIGINAL = exports.TASK_BUCKET_NAMES_ORIGINAL = exports.TASK_BUCKET_NAMES_PROD = exports.TASK_BUCKET_NAMES_DEV = void 0;
exports.TASK_BUCKET_NAMES_DEV = {
    audio: 'levante-assets-dev/audio',
    visual: 'levante-assets-dev/visual',
    corpus: 'levante-assets-dev/corpus',
    translations: 'levante-assets-dev/translations',
};
exports.TASK_BUCKET_NAMES_PROD = {
    audio: 'levante-assets-prod/audio',
    visual: 'levante-assets-prod/visual',
    corpus: 'levante-assets-prod/corpus',
    translations: 'levante-assets-prod/translations',
};
exports.TASK_BUCKET_NAMES_ORIGINAL = {
    intro: 'intro-levante',
    vocab: 'vocab-test',
    memoryGame: 'roar-memory-game',
    roarInference: 'roar-inference',
    adultReasoning: 'egma-math',
    heartsAndFlowers: 'roar-hearts-and-flowers',
    egmaMath: 'egma-math',
    matrixReasoning: 'matrix-reasoning',
    sameDifferentSelection: 'same-different-selection',
    trog: 'roar-syntax',
    mentalRotation: 'mental-rotation',
    theoryOfMind: 'theory-of-mind',
    shared: 'levante-tasks-shared-prod',
};
exports.TRANSLATION_URL_ORIGINAL = 'https://storage.googleapis.com/road-dashboard/item-bank-translations.csv';
